import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store/store";
import {
  ICountries,
  IPolicyTemplate,
  IPrograms,
  IStepTwo,
} from "./types/StepTwo-inerface";

const StepTwoState = (state: RootState): IStepTwo => state.StepTwoHealth;

export const FormFieldsStepTwo = createSelector(
  [StepTwoState],
  (state): IStepTwo => state
);
export const CountriesData = createSelector(
  [StepTwoState],
  (state): ICountries => state.Countries
);
export const policyTemplate = createSelector(
  [StepTwoState],
  (state): IPolicyTemplate => state.PolicyTemplate
);

export const programs = createSelector(
    [StepTwoState],
    (state): IPrograms => state.ProgramsRequest,
)
